import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=96160fe0&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=96160fe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96160fe0",
  null
  
)

export default component.exports
import {QPage,QList,QItem,QItemSection,QField,QItemLabel,QIcon} from 'quasar'
component.options.components = Object.assign({QPage,QList,QItem,QItemSection,QField,QItemLabel,QIcon}, component.options.components || {})
